export { createAPI as createAllyHostAPI } from './accessibility';
